import React from "react";
import Carousel from "react-bootstrap/Carousel";
import CarouselAuto from "../components/carouselAuto/CarouselAuto";
import images from "../exports/images";
import useBusiness from "../hooks/useBusiness";
import { isVideov2 } from "../helpers/isVideo";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { getURLFromImageBackground } from "../helpers/functions";

const Institucional = () => {
  const { business } = useBusiness();
  const arrayImages = [...images[2]];

  const imageUrl = business && Object.keys(business).length > 0 && getURLFromImageBackground(business?.imageBloqueBusiness);

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>{business?.bannerBusinessTitle}</title>
          <meta name="title" content={`${business?.bannerBusinessTitle}`} />
          <meta name="description" content={`${business?.sliderPrimaryDescription}`} />

          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://tensolite.com/somos-tensolite"
          />
          <meta property="og:title" content={`${business?.bannerBusinessTitle}`} />
          <meta property="og:description" content={`${business?.sliderPrimaryDescription}`} />
          <meta property="og:image" content={`${imageUrl}`} />

          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://tensolite.com/somos-tensolite"
          />
          <meta property="twitter:title" content={`${business?.bannerBusinessTitle}`} />
          <meta property="twitter:description" content={`${business?.sliderPrimaryDescription}`} />
          <meta property="twitter:image" content={`${imageUrl}`} />

          <script type="application/ld+json">
            {`
            "@context": "https://schema.org",
            "@type": "Organization" ,
            "name": "Tensolite",
            "description": "${business?.sliderPrimaryDescription}",
            "url": "https://tensolite.com/somos-tensolite",
            "image": "${imageUrl}",
          `}
          </script>
        </Helmet>
      </HelmetProvider>
      <section id="institucional__institucional">
        {business && (
          <article
            className="institucional__bg-start align-items-center bg-fullpage"
            aria-label="Presentación de Institucional de Tensolite"
          >
            {isVideov2(business?.imageBusiness?.[0]?.url) ? <video
              src={
                business?.imageBusiness ? business?.imageBusiness?.[0]?.url : ""
              }
              autoPlay
              muted
              loop
            /> : <img
              src={business?.imageBusiness ? business?.imageBusiness?.[0]?.url : ""}
              alt={business?.imageBusiness ? business?.imageBusiness?.[0]?.alt : business?.title}
            />}
            <div className="card-info">
              <div className="cuadrado-azul"></div>
              <h1>{business?.sliderPrimaryDescription}</h1>
            </div>
          </article>
        )}

        <article className="container card-info2 institucional__bg-2 col-img-r px-lg-4">
          <div role="presentation" className="block-img-responsive card-text-2 col-sm-12 col-lg-6">
            <h3 className="text-lg-start text-big">{business?.bannerBusinessTitle}</h3>
          </div>
          <div role="presentation" className="card-text-2 col-sm-12 col-lg-6">
            <p className="text-lg-end text-color">{business?.bannerBusinessDescription}</p>
          </div>
        </article>
      </section>

      <Carousel fade id="institucional__carroussel-mvp" className="carrousel" pause="hover">
        {business?.sliderSecondary?.map((slider, index) => (
          <Carousel.Item key={`carousel-item-${index}`} id={index} className="block-img-responsive">
            {isVideov2(slider?.imageSliderBusiness?.[0]?.url) ? <video
              className="img-responsive-inter"
              src={
                slider?.imageSliderBusiness ? slider?.imageSliderBusiness?.[0]?.url : ""
              }
              autoPlay
              muted
              loop
            /> : <img
              className="img-responsive-inter"
              src={slider?.imageSliderBusiness ? slider?.imageSliderBusiness?.[0]?.url : ""}
              alt=""
            />}
            <Carousel.Caption className="card-info">
              <div rol="presentation" className="cuadrado-azul"></div>
              <h2>{slider?.title}</h2>
              <p dangerouslySetInnerHTML={{ __html: slider?.description }}>
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      <section id="institucional__historia" className="container d-flex flex-no-wrap in">
        <div className="block-img-responsive col-sm-12 col-md-6 col-lg-6 inLeft">
          <picture>
            <source
              media="(orientation: portrait) and (max-width: 1199px)"
              className="img-responsive zoomOut"
              srcSet={
                business?.imageBloqueBusiness_mobile
                  ? business?.imageBloqueBusiness_mobile?.[0]?.url
                  : ""
              }
              alt={
                business?.imageBloqueBusiness_mobile
                  ? business?.imageBloqueBusiness_mobile?.[0]?.alt
                  : business?.title
              }
              title={business?.title}
            />
            {isVideov2(business?.imageBloqueBusiness?.[0]?.url) ? <video
              className="img-responsive zoomOut"
              src={
                business?.imageBloqueBusiness ? business?.imageBloqueBusiness?.[0]?.url : ""
              }
              autoPlay
              muted
              loop
            /> : <img
              src={business?.imageBloqueBusiness ? business?.imageBloqueBusiness?.[0]?.url : ""}
              alt={
                business?.imageBloqueBusiness
                  ? business?.imageBloqueBusiness?.[0]?.alt
                  : business?.title
              }
              className="img-responsive zoomOut"
            />}
          </picture>
        </div>
        <div className="text-card-historico col-12 col-sm-12 col-md-6 col-lg-6 inRight">
          <header>
            <h2 className="id-section">{business?.bloqueTitle}</h2>
          </header>

          <p
            className="empresa-tiny-editor"
            dangerouslySetInnerHTML={{ __html: business?.bloqueDescription }}
          ></p>
        </div>
      </section>

      <aside className="institucional__product container">
        <h3 className="id-section">Nuestros principales productos</h3>
      </aside>
      <br />
      <CarouselAuto images={arrayImages} />
    </>
  );
};
export default Institucional;
